module.exports = __webpack_public_path__ + "static/media/Avatars_Male-21.7b269c31.png";